import { MAX_IMAGE_BYTES } from '../shared/domain';

export interface CompressedImage { blob: Blob; previewUrl: string; width: number; height: number; }

export async function compressToWebP(file: File, maxSide: number): Promise<CompressedImage> {
  if (!file.type.startsWith('image/')) throw new Error('Seleziona un file immagine');
  if (file.size > 12 * 1024 * 1024) throw new Error('Il file originale supera 12 MB');
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width; canvas.height = height;
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) throw new Error('Compressione immagini non supportata');
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();
  let blob: Blob | null = null;
  for (const quality of [0.88, 0.8, 0.72, 0.64, 0.56, 0.48]) {
    blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', quality));
    if (blob && blob.size <= MAX_IMAGE_BYTES) break;
  }
  if (!blob || blob.size > MAX_IMAGE_BYTES) throw new Error('Impossibile comprimere sotto 850 KiB');
  return { blob, previewUrl: URL.createObjectURL(blob), width, height };
}

export function randomToken(bytes = 32): string {
  const data = crypto.getRandomValues(new Uint8Array(bytes));
  return btoa(String.fromCharCode(...data)).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
}
